import React from "react";
import { Route, Routes } from "react-router-dom";
import Contact from "./contact";
import Header from "../../../components/layout-components/Header";
import Footer from "../../../components/layout-components/Footer";
import About from "./about";
import Home from "./home";
import Members from "./members";
import MemberDetail from "./members/components/MemberDetail";
import Events from "./events";
import EventDetail from "./events/components/EventDetail";
import Membership from "./membership";
import BoardsSections from "./boards";
import { useMediaQuery, useTheme } from "@mui/material";
import MobileHeader from "../../../components/layout-components/MobileHeader";
import ScrollToTop from "../../../components/core-components/scrolltop/ScrollToTop";
import PrivacyPolicy from "./PrivacyPolicy"; // Yeni import
import RefundPolicy from "./RefundPolicy";   // Yeni import

function SiteLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <ScrollToTop />
      {!isMobile ? <Header /> : <MobileHeader />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/uyeler" element={<Members />} />
        <Route path="/uyeler/:id/:name" element={<MemberDetail />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/etkinlikler" element={<Events />} />
        <Route path="/etkinlikler/:id/:title" element={<EventDetail />} />
        <Route path="/kurullar" element={<BoardsSections />} />
        <Route path="/uyelik" element={<Membership />} />
        {/* YENİ ROUTE'LAR */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default SiteLayout;
